import React, { useState } from 'react';
import { arrayOf, shape, string, func, object, oneOfType, number } from 'prop-types';
import currencyFormatter from '@magalu/stereo-ui-utils/currencyFormatter';
import { ProfitsLabels, servicePriceLabel, installmentLabel } from './common-service.data';
import { ProfitLabel, Container } from './common-service.styles';
import { TitleContent, Description } from '../financial-services.styles';
import RadioGroup from '../../../molecules/RadioGroup';

const CommonService = ({
  service,
  onChange,
  Icon,
  defaultOption,
  installmentQuantity
}) => {
  var _service$offers;

  if (!(service != null && service.offers.length)) return null;
  const [selected, setSelected] = useState(defaultOption[0]);

  const handleChange = (e, option) => {
    setSelected(option);
    onChange(e, option);
  };

  const options = service == null ? void 0 : (_service$offers = service.offers) == null ? void 0 : _service$offers.map(item => ({
    id: item == null ? void 0 : item.id,
    value: item == null ? void 0 : item.id,
    price: item == null ? void 0 : item.price,
    label: `${servicePriceLabel(item == null ? void 0 : item.description, currencyFormatter({
      value: item == null ? void 0 : item.price
    }))}${installmentLabel(installmentQuantity, currencyFormatter({
      value: (item == null ? void 0 : item.price) / installmentQuantity
    }))}`,
    description: item == null ? void 0 : item.description,
    treeId: item == null ? void 0 : item.treeId,
    wageCompensation: item == null ? void 0 : item.wageCompensation
  }));
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TitleContent, null, /*#__PURE__*/React.createElement(Icon, {
    "aria-hidden": true
  }), /*#__PURE__*/React.createElement(Description, {
    as: "p"
  }, service == null ? void 0 : service.description)), /*#__PURE__*/React.createElement(Container, {
    mb: '15px',
    mt: '10px'
  }, ProfitsLabels.map((profit, i) => /*#__PURE__*/React.createElement(ProfitLabel, {
    key: `${profit}${i}`
  }, profit))), /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(RadioGroup, {
    options: options.concat(defaultOption),
    selectedOption: selected == null ? void 0 : selected.value,
    onChange: handleChange,
    p: '12px 0'
  })));
};

process.env.NODE_ENV !== "production" ? CommonService.propTypes = {
  service: shape({
    items: arrayOf(shape({
      id: oneOfType([string, number]),
      description: string
    })),
    description: string
  }),
  Icon: object,
  onChange: func,
  defaultOption: arrayOf(shape({})),
  installmentQuantity: oneOfType([string, number])
} : void 0;
CommonService.defaultProps = {
  service: {
    offers: []
  },
  onChange: () => ({}),
  defaultOption: [],
  installmentQuantity: null
};
export default CommonService;